import React, { useEffect, useState } from "react";
import {
  DateInput,
  RadioInput,
  SelectInput,
} from "../../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { inmateAction } from "../../../_store";
import { fDate, MinDate, Today } from "../../../utils/formatTime";
import Button from "./../../../components/common/ui/Button";
import { useLocation } from "react-router-dom";
import generateVisitorPDF from "../../../components/common/export/Reports/generateVisitorPDF ";
import CustomLoader from "../../../components/common/ui/Loader";
import generateAdminRemedyPDF from "../../../components/common/export/Reports/generateAdminRemedyPDF";
import generateRffFormPDF from "../../../components/common/export/Reports/generateRffFormPDF";
import loaddataimg from "../../../assets/svg/load-data.svg";
import generateLegalResearchPDF from "../../../components/common/export/Reports/generateLegalResearchPDF";
import { notice } from "./../../../_store/notice.slice";
import { pdf } from "@react-pdf/renderer";

const Requests = ({ loadData, render }) => {
  const location = useLocation();
  const { inmate: Inmate } = location.state || {};

  const { commonFacilityCode } = useSelector((x) => x.auth);
  const { facilityDropDown } = useSelector((x) => x.master);
  const { requestType } = useSelector((x) => x.dropdownOptions);
  const { user } = useSelector((x) => x.auth);
  const userRoleID = user?.UserRoleID;
  const loggedUserName = user?.UserName;
  const {
    formTypedropdownList,
    visitorsFormrecords,
    FormHeader,
    VFRFormRecords: VisitorRequestFormrecords,
    ARFFormRecords: chkARFFormRecords,
    RequestAdminRemedy,
    AdminRemedyFormHeader,
    adminRemedyForm,
    RFFFormRecords,
    noticeId,
    request,
    loading,
    inmate,
  } = useSelector((x) => x.inmate);
  const dispatch = useDispatch();
  useEffect(() => {
    setAllowDownload(loadData);
    dispatch(
      inmateAction.setRequest({
        FacilityID:
          Inmate?.facilityID || inmate?.facilityID || commonFacilityCode,
        InmatesId: Inmate?.InmateID || inmate?.InmateID,
        InmateResidentID: "",
        PodID: 0,
        Type: 1,
        RequestFormTypeID: 0,
        NoticesID: 1,
        UserFirstName: "",
        UserLastName: "",
        ActiveStatus: 3,
        NoticesFromDate: "",
        NoticesToDate: "",
        DobStartDate: "",
        DobEndDate: "",
        ManagementUserID: user?.ManagementUserID,
        SortField: "",
      })
    );
  }, [render]);

  useEffect(() => {
    if (FormHeader?.length > 0) {
      dispatch(inmateAction.setNoticeId(FormHeader[0].RequestFormTypeID));
    }
  }, [FormHeader]);

  useEffect(() => {
    if (AdminRemedyFormHeader?.length > 0) {
      dispatch(
        inmateAction.setRequestAdminRemedy(
          AdminRemedyFormHeader[0].RequestFormTypeID
        )
      );
    }
  }, [AdminRemedyFormHeader]);

  useEffect(() => {
    if (
      VisitorRequestFormrecords?.length > 0 ||
      chkARFFormRecords?.length > 0 ||
      RFFFormRecords?.length > 0
    ) {
      setDisable(true);
      setAllowDownload(true);
    } else {
      setDisable(false);
    }
  }, [chkARFFormRecords, RFFFormRecords, VisitorRequestFormrecords]);

  useEffect(() => {
    let param1 = {
      ...request,
      ManagementUserID: user?.ManagementUserID,
      FacilityID:
        Inmate?.facilityID || inmate?.facilityID || commonFacilityCode,
      InmatesId: Inmate?.InmateID || inmate?.InmateID,
      NoticesID: 1,
    };
    dispatch(inmateAction.RequestFormTypeReport(param1));

    let param2 = {
      ...request,
      ManagementUserID: user?.ManagementUserID,
      FacilityID:
        Inmate?.facilityID || inmate?.facilityID || commonFacilityCode,
      InmatesId: Inmate?.InmateID || inmate?.InmateID,
      NoticesID: 2,
    };
    dispatch(inmateAction.RequestFormTypeReport(param2));

    dispatch(
      inmateAction.GetManagementRequestFormDropDown({
        mangementUserID: user?.ManagementUserID,
        facilityId: commonFacilityCode,
      })
    );

    dispatch(
      inmateAction.setRequest({
        ...request,
        FacilityID:
          Inmate?.facilityID || inmate?.facilityID || commonFacilityCode,
        InmatesId: Inmate?.InmateID || inmate?.InmateID,
        ManagementUserID: user?.ManagementUserID,
      })
    );
  }, []);

  // const [request, setRequest] = useState({
  //   FacilityID: Inmate?.facilityID,
  //   InmatesId: Inmate?.InmateID,
  //   InmateResidentID: "0",
  //   PodID: 0,
  //   Type: 1,
  //   RequestFormTypeID: 0,
  //   NoticesID: 1,
  //   UserFirstName: "",
  //   UserLastName: "",
  //   ActiveStatus: 3,
  //   NoticesFromDate: "",
  //   NoticesToDate: "",
  //   DobStartDate: "",
  //   DobEndDate: "",
  //   ManagementUserID: user?.ManagementUserID,
  //   SortField: "",
  // });

  const [allowDownload, setAllowDownload] = useState(false);
  const [disable, setDisable] = useState(false);

  const handleChange = (e) => {
    let { value } = e?.target;

    setAllowDownload(false);

    dispatch(
      inmateAction.setRequest({
        ...request,
        Type: parseInt(value), // Always set the Type
        ...(parseInt(value) === 2 && { NoticesID: parseInt(value) }),
      })
    );

    // setRequest((prev) => ({
    //   ...prev,
    //   Type: parseInt(value), // Always set the Type
    //   ...(parseInt(value) === 2 && { NoticesID: parseInt(value) }), // Conditionally add NoticesID
    // }));
  };

  const handleDateChange = (value, name) => {
    const date = fDate(value);

    dispatch(
      inmateAction.setRequest({
        ...request,
        [name]: date,
      })
    );

    // setRequest((prev) => ({
    //   ...prev,
    //   [name]: date,
    // }));
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && request[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "NoticesFromDate") {
      if (
        request.NoticesToDate &&
        new Date(value) > new Date(request.NoticesToDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "NoticesToDate") {
      if (
        request.NoticesFromDate &&
        new Date(value) < new Date(request.NoticesFromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...request,
      NoticesFromDate:
        fieldName === "NoticesFromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : request.NoticesFromDate, // preserve existing value
      NoticesToDate:
        fieldName === "NoticesToDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : request.NoticesToDate, // preserve existing value
    };
    dispatch(inmateAction.setRequest(updatedParam));
  };

  const handleSelectChange = (selectedOption, name) => {
    dispatch(
      inmateAction.setRequest({
        ...request,
        [name]: selectedOption?.value ? parseInt(selectedOption?.value) : 0,
      })
    );
    // setRequest((prev) => ({
    //   ...prev,
    //   [name]: parseInt(selectedOption?.value),
    // }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setAllowDownload(true);
    if (request?.Type === 1) {
      // dispatch(inmateAction.InmateRequestVisitorInfo(noticeId || 0));
      // dispatch(
      //   inmateAction.LoadRequestFormTypeReportExportList({
      //     ...request,
      //     NoticesID: noticeId,
      //   })
      // );
      let param = {
        facilityID: request?.FacilityID,
        inmatesId: request?.InmatesId,
        inmateResidentId: request?.InmateResidentID,
        podId: request?.PodID,
        noticesID: 1,
        userFirstName: request?.UserFirstName,
        userLastName: request?.UserLastName,
        ActiveStatus: request?.ActiveStatus,
        noticesFromDate: request?.NoticesFromDate,
        noticesToDate: request?.NoticesToDate,
        dobStartDate: request?.DobStartDate,
        dobEndDate: request?.DobEndDate,
        managementUserID: user?.ManagementUserID,
        sortField: "RequestReSubmitDate DESC",
        // RequestFormTypeID: 1,
      };
      dispatch(inmateAction.LoadRequestFormTypeReportExportList(param));
    } else if (request?.Type === 2) {
      let param = {
        facilityID: request?.FacilityID,
        inmatesId: request?.InmatesId,
        inmateResidentId: request?.InmateResidentID,
        podId: request?.PodID,
        noticesID: 2,
        userFirstName: request?.UserFirstName,
        userLastName: request?.UserLastName,
        ActiveStatus: request?.ActiveStatus,
        noticesFromDate: request?.NoticesFromDate,
        noticesToDate: request?.NoticesToDate,
        dobStartDate: request?.DobStartDate,
        dobEndDate: request?.DobEndDate,
        managementUserID: user?.ManagementUserID,
        sortField: "RequestReSubmitDate DESC",
        // RequestFormTypeID: 1,
      };
      dispatch(inmateAction.LoadRequestFormTypeReportExportList(param));
      // Promise.all(
      //   AdminRemedyFormHeader.map((item) =>
      //     dispatch(
      //       inmateAction.LoadInmateRequestAdminRemedy(item.RequestFormTypeID)
      //     )
      //   )
      // );
    } else if (request?.Type === 3) {
      let param = {
        facilityID: request?.FacilityID,
        inmatesId: request?.InmatesId,
        requestFormTypeID: request?.RequestFormTypeID,
        managementUserID: user?.ManagementUserID,
        dobStartDate: request?.NoticesFromDate,
        dobEndDate: request?.NoticesToDate,
      };
      if (request?.RequestFormTypeID === 60) {
        dispatch(inmateAction.LoadLRRFormInmateExport(param));
      } else {
        dispatch(inmateAction.LoadRequestThreadInmateExport(param));
      }
    }
  };

  const handleDownload = (e) => {
    // Sample Data
    e.preventDefault();

    if (request?.Type === 1) {
      if (VisitorRequestFormrecords.length > 0) {
        // Dispatch action to fetch visitor info, then handle the response
        dispatch(
          inmateAction.InmateRequestVisitorInfo(
            VisitorRequestFormrecords[0]?.RequestFormTypeID
          )
        )
          .then((res) => {
            // Title for the document
            const title = "Visitors";
            // Map the response data into a format suitable for the PDF
            const visitorsData = res?.payload?.map((obj) => ({
              Action: obj?.RequestVisitorStatus,
              Name: obj?.VisitorName || "N/A",
              DOB: obj?.DOB || "N/A",
              Relation: obj?.Relation || "N/A",
              PhoneNumber: obj?.PhoneNo || "N/A",
              Address: obj?.StreetName || "N/A",
              City: obj?.City || "N/A",
              State: obj?.StateName || "N/A",
              ZIP: obj?.ZIP || "N/A",
              ResubmittedDate: obj?.RequestReSubmitDate || "N/A",
              RespondedDate: obj?.RequestRespondDate || "N/A",
              DissaprovalSection:
                obj?.IsAddressIncomplete !== 0
                  ? "Address Incomplete, Former Inmate, Visitor Victim"
                  : "",
              Others: obj?.ReqDisApprovedReason || "N/A",
            }));

            // Extract other necessary data for the PDF header
            const facilityName = FormHeader[0]?.PodCode || "N/A";
            const inmateName = FormHeader[0]?.InmateName || "N/A";
            const inmateId = FormHeader[0]?.InmateResidentId || "N/A";
            const date = FormHeader[0]?.RequestCreateDate || "N/A";

            // Generate the visitor PDF with the formatted data
            generateVisitorPDF(
              facilityName,
              inmateName,
              inmateId,
              date,
              visitorsData,
              title
            );

            // Disable the download and enable buttons as needed
            setAllowDownload(false);
            setDisable(false);

            // Clear any visitor data from the store
            dispatch(inmateAction.clearVisitorData());
          })
          .catch((error) => {
            // Handle any errors that occur during the dispatch or data processing
            console.error("Error fetching visitor data:", error);
          });
      }
    } else if (request?.Type === 2) {
      // Dispatch all the API calls using Promise.all
      Promise.all(
        chkARFFormRecords?.map((item) =>
          dispatch(
            inmateAction.LoadInmateRequestAdminRemedy(item.RequestFormTypeID)
          )
        )
      )
        .then((responses) => {
          // This block will run after all API calls are completed
          const payloadValues = responses.map((item) => item.payload).flat();
          const title = "Administrator Remedy Form";

          // Process the response data to the required format
          const adminRemedyData = payloadValues?.map((object) => ({
            POD: object?.PodCode || "N/A",
            Grievance:
              [
                object?.GrvOriginal === 1 ? "Original" : "",
                object?.GrvAppeal === 1 ? "Appeal" : "",
                object?.GrvDisciplinaryActionAppeal === 1
                  ? "Disciplinary Action Appeal"
                  : "",
              ]
                .filter(Boolean) // Remove empty strings
                .join(", ") || "N/A", // Join values with commas, fallback to "N/A"
            Description: object?.GrievanceBody || "N/A",
            ReceivedBy: object?.GrievanceReceivedUser || "N/A",
            DateReceived: object?.GrievanceReceivedDate || "",
            Forwarded: object?.GrievanceForward === 1 ? "Yes" : "No",
            Investigation: object?.InvestigationBody || "-",
            CompletedBy:
              (userRoleID === 1 &&
                object?.InvestigationCompletedByMUUserName != null &&
                object?.InvestigationCompletedByMUUserName !== ""
                ? object?.InvestigationCompletedByMUUserName
                : object?.InvestigationCompletedByUser != null &&
                  object?.InvestigationCompletedByUser !== ""
                  ? object?.InvestigationCompletedByUser
                  : loggedUserName) || "N/A",
            ReviewFindings: object?.ReviewFindingsBody || "-",
            Date: object?.SignatureDate || "",
            SupervisorSignature: object?.SupervisorSignature || "-",
            SupervisorTitle: object?.SupervisorTitle || "-",
          }));

          // Extract inmate details for the header
          const inmateName = AdminRemedyFormHeader[0]?.InmateName;
          const inmateId = AdminRemedyFormHeader[0]?.InmateResidentId;
          // Generate the PDF with the extracted data
          // generateAdminRemedyPDF(inmateName, inmateId, adminRemedyData, title);

          const doc = pdf(
            generateAdminRemedyPDF({
              inmateName,
              inmateId,
              adminRemedyData,
              title,
            })
          );

          // Convert the document to Blob and trigger download
          doc.toBlob().then((blob) => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Admin_Remedy_Form.pdf"; // Name of the downloaded PDF
            link.click();
          });

          // Reset flags and clear previous data
          setAllowDownload(false);
          setDisable(false);
          dispatch(inmateAction.clearVisitorData()); // Clear any visitor data
        })
        .catch((error) => {
          // Handle any errors that occur during the API calls
          console.error("Error fetching admin remedy data:", error);
        });
    } else if (request?.Type === 3) {
      if (request?.RequestFormTypeID !== 60) {
        const title = "Request Forum Form";

        const rffFormData = RFFFormRecords?.map((rffObj) => ({
          RequestForumThreadID: rffObj?.RequestForumThreadID || "N/A",
          Title: rffObj?.RequestTitle || "N/A",
          PODCode: rffObj?.PodCode || "N/A",
          CreatedOn: rffObj?.ReqestCreateDate || "N/A",
          Request: rffObj?.RequestBody || "N/A",
          PostedBy: rffObj?.RequestRespondBy || "N/A",
          SentDateTime: rffObj?.ReqestPostDate || "N/A",
        }));

        const inmateName = RFFFormRecords[0]?.InmateFullName;
        const inmateId = RFFFormRecords[0]?.InmateResidentId;

        generateRffFormPDF(inmateName, inmateId, rffFormData, title);
        setAllowDownload(false);
        setDisable(false);
        dispatch(inmateAction.clearVisitorData());
      } else if (request?.RequestFormTypeID === 60) {
        const title = "Legal Information Request Form";
        const dynamicData = RFFFormRecords?.map((rffObj) => ({
          referenceId: rffObj?.ReferrenceID || "-",
          lastName: rffObj?.LastName || "-",
          firstName: rffObj?.FirstName || "-",
          middleName: rffObj?.MiddleName || "-",
          inmateId: rffObj?.InmateResidentId || "-",
          housingUnit: rffObj?.HousingUint || "-",
          whoSent:
            rffObj?.IRRFWhoSentID === 6
              ? "Other State(Complete next field)"
              : rffObj?.WhoSent,
          specifyOthers: rffObj?.IRRFWhoSentID === 6 ? rffObj?.WhoSent : "-",
          courtDate: rffObj?.NextCourtDate || "",
          charges: rffObj?.CurrentCharges || "-",
          IsConvicted: rffObj?.IsConvicted === 1 ? "Yes" : "No",
          sentenced: rffObj?.IsSentenced === 1 ? "Yes" : "No",
          researchMatter: rffObj?.ResearchReason || "-",
          IsProSe: rffObj?.IsProSe === 1 ? "Yes" : "No",
          IsProSes: rffObj?.IsProSe === 1 ? "Yes" : "No",
          IfIsLawyerRepresentText: rffObj?.IfIsLawyerRepresentText,

          jurisdiction:
            rffObj?.IRRFJurisdictionReasonID === 7
              ? "Other State(Complete next field)"
              : rffObj.JurisdictionReason,
          otherState:
            rffObj?.IRRFJurisdictionReasonID === 7
              ? rffObj.JurisdictionReason
              : "-",

          infoToReceive: "-",
          Information1: rffObj?.Information1 || "-",
          Information2: rffObj?.Information2 || "-",
          Information3: rffObj?.Information3 || "-",
          Information4: rffObj?.Information4 || "-",
          Information5: rffObj?.Information5 || "-",
        }));
        const inmateName = FormHeader[0]?.InmateName;
        const inmateId = FormHeader[0]?.InmateResidentId;
        generateLegalResearchPDF(title, dynamicData, inmateName, inmateId);
        setAllowDownload(false);
        setDisable(false);
        dispatch(inmateAction.clearVisitorData());
      }
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setAllowDownload(false);
    setDisable(false);
    dispatch(inmateAction.clearVisitorData());
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <>
      <div className=" p-2">
        <h4 className="inner-header-bg text-color">
          {" "}
          <i className="fa-solid fa-filter me-2"></i>Filter{" "}
        </h4>
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="row">
            <div className="mb-3">
              <label className="mb-2 fw-bold">Type</label>
              <RadioInput
                name="Type"
                id="Type"
                // label="Type"
                selectedValue={request?.Type}
                handleChange={(e) => handleChange(e)}
                options={requestType}
                disabled={disable}
              // required
              />
            </div>
          </div>

          {/* Conditional Rendering for Type === 3 */}

          {/* Row for From Date */}
          <div className="row">
            {request?.Type === 3 && (
              <div className={"col-sm-6 col-md-4"}>
                <div className="form-floating mb-3">
                  <SelectInput
                    options={formTypedropdownList}
                    value={request?.RequestFormTypeID}
                    handleChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "RequestFormTypeID")
                    }
                    closeMenuOnSelect={true}
                    isDisabled={disable}
                    isLoading={false}
                    isClearable={request?.RequestFormTypeID !== 0}
                    placeholder="Select Form"
                    label="Form"
                  />
                </div>
              </div>
            )}
            <div
              className={
                request?.Type === 3 ? "col-sm-6 col-md-4" : "col-sm-6 col-md-6"
              }
            >
              <div className="form-floating mb-3">
                <DateInput
                  value={request?.NoticesFromDate}
                  handleChange={(e) => handleDateChange(e, "NoticesFromDate")}
                  name="NoticesFromDate"
                  label="From Date"
                  maxDate={
                    request?.NoticesToDate ? request?.NoticesToDate : new Date()
                  }
                  required={false}
                  disabled={disable}
                  yearDropDown={false}
                  monthDropDown={false}
                  className={false ? "disabled-date-input" : ""} // Conditional class
                  isClearable={request.NoticesFromDate}
                  preventClear={!request.NoticesFromDate}
                  minDate={new Date(2017, 0, 1)}
                  handleBlur={(e) => handleDateBlur(e, "NoticesFromDate")}
                  handleKeyDown={(e) =>
                    handleDateEnterKey(e, "NoticesFromDate")
                  }
                />
              </div>
            </div>
            <div
              className={
                request?.Type === 3 ? "col-sm-6 col-md-4" : "col-sm-6 col-md-6"
              }
            >
              <div className="form-floating mb-3">
                <DateInput
                  value={request?.NoticesToDate}
                  handleChange={(e) => handleDateChange(e, "NoticesToDate")}
                  name="NoticesToDate"
                  // Set minDate to FromDate
                  minDate={
                    request?.NoticesFromDate
                      ? request?.NoticesFromDate
                      : new Date(2017, 0, 1)
                  }
                  label="To Date"
                  maxDate={new Date()}
                  required={false}
                  disabled={disable}
                  yearDropDown={false}
                  monthDropDown={false}
                  isClearable={request.NoticesToDate}
                  preventClear={!request.NoticesToDate}
                  handleBlur={(e) => handleDateBlur(e, "NoticesToDate")}
                  handleKeyDown={(e) => handleDateEnterKey(e, "NoticesToDate")}
                />
              </div>
            </div>
          </div>

          <div className="mt-3 d-flex flex-wrap  gap-3">
            {VisitorRequestFormrecords &&
              VisitorRequestFormrecords?.length > 0 &&
              allowDownload && (
                <div className="d-flex flex-wrap align-items-start">
                  <label className="fs-5 fw-bold" style={{ color: "#009759" }}>
                    Data loaded successfully. Click download button to export
                    PDF.
                  </label>
                </div>
              )}

            {chkARFFormRecords &&
              chkARFFormRecords?.length > 0 &&
              allowDownload && (
                <div className="d-flex flex-wrap align-items-start">
                  <label className="fs-5 fw-bold" style={{ color: "#009759" }}>
                    Data loaded successfully. Click download button to export
                    PDF.
                  </label>
                </div>
              )}

            {RFFFormRecords && RFFFormRecords?.length > 0 && allowDownload && (
              <div className="d-flex flex-wrap align-items-start">
                <label className="fs-5 fw-bold" style={{ color: "#009759" }}>
                  Data loaded successfully. Click download button to export PDF.
                </label>
              </div>
            )}

            {(request?.Type === 1 &&
              VisitorRequestFormrecords?.length === 0 &&
              allowDownload) ||
              (request?.Type === 2 &&
                chkARFFormRecords?.length === 0 &&
                allowDownload) ||
              (request?.Type !== 1 &&
                request?.Type !== 2 &&
                RFFFormRecords?.length === 0 &&
                allowDownload) ? (
              <div className="d-flex flex-wrap align-items-start">
                <label className="fs-5 fw-bold text-danger">
                  No Data Available
                </label>
              </div>
            ) : null}

            <div className="d-flex flex-wrap ms-auto">
              {VisitorRequestFormrecords?.length === 0 &&
                chkARFFormRecords?.length === 0 &&
                RFFFormRecords?.length === 0 && (
                  <Button
                    className="me-2"
                    label={"LOAD DATA"}
                    imgsrc={loaddataimg}
                    type={"submit"}
                    status={"btn-label"}
                    disabled={false}
                  ></Button>
                )}
              {(VisitorRequestFormrecords?.length > 0 ||
                chkARFFormRecords?.length > 0 ||
                RFFFormRecords?.length > 0) &&
                allowDownload && (
                  <>
                    <Button
                      className="me-2"
                      label={"CANCEL"}
                      type={"submit"}
                      variant="danger"
                      status={"primary"}
                      icon={"fa-solid fa-xmark"}
                      disabled={false}
                      onClick={handleCancel}
                    />
                    <Button
                      className="me-2"
                      label={"Download"}
                      icon={"fa-solid fa-download"}
                      type={"button"}
                      status={"success"}
                      disabled={false}
                      onClick={(e) => handleDownload(e)}
                    ></Button>
                  </>
                )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default React.memo(Requests);
